enum CloseReasonEnum {
    LostToOther = 'LOST_TO_OTHER',
    Stale = 'STALE',
}

export default CloseReasonEnum;
